var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "12", height: "20", viewBox: "0 0 12 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.09375 13.2334C8.37904 13.5337 8.36687 14.0085 8.06656 14.2938C7.76626 14.579 7.29154 14.5669 7.00625 14.2666L3.20625 10.2666C2.93125 9.97709 2.93125 9.52291 3.20625 9.23344L7.00625 5.23344C7.29154 4.93313 7.76626 4.92096 8.06656 5.20625C8.36687 5.49154 8.37904 5.96626 8.09375 6.26656L4.78448 9.75L8.09375 13.2334Z", fill: "#303030" })
  );
});